import { Info } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";

export default function PublicVisibilitySettings({
  publicStory, setPublicStory,
  isPublic, setIsPublic,
  canBePublic,
  showDonationTip,
}) {
  return (
    <>
      <div>
        <Label htmlFor="public-story">Public Story (donor-facing text)</Label>
        <Textarea
          id="public-story"
          value={publicStory}
          onChange={(e) => setPublicStory(e.target.value)}
          placeholder="A warm, donor-friendly version of this animal's story. Leave blank to show the case history instead."
          data-testid="public-story-input"
          className="mt-1.5 min-h-[80px]"
        />
      </div>

      <div className="flex items-center justify-between py-1">
        <div>
          <Label htmlFor="is-public">Show on Public Site</Label>
          {!canBePublic && <p className="text-xs text-amtm-textMuted mt-0.5">Passed Away cases cannot be shown publicly.</p>}
        </div>
        <Switch id="is-public" checked={isPublic && canBePublic} onCheckedChange={setIsPublic} disabled={!canBePublic} data-testid="is-public-toggle" />
      </div>

      {showDonationTip && (
        <div className="flex items-start gap-2 bg-amtm-warning/10 text-amtm-warning rounded-xl p-3 text-sm" data-testid="public-donation-tip">
          <Info className="h-4 w-4 shrink-0 mt-0.5" />
          <p>Tip: set a donation amount and Razorpay link so donors can contribute.</p>
        </div>
      )}
    </>
  );
}
